module.exports = __webpack_public_path__ + "img/silver14.73ff66b9.gif";